export default "__VITE_ASSET__cf3ede40__$_?component__"